// src/components/TestimonialModal.js
// Updated: 12/01/2025 06:20 PM

import React, { useState } from 'react';
import {
  Modal, Box, Typography, TextField, Button,
  FormControlLabel, Checkbox, FormGroup, CircularProgress
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function TestimonialModal({ open, onClose, onSave, loading }) {
  const [text, setText] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);

  const handleSave = () => {
    if (!text) {
      alert('Please enter your testimony.');
      return;
    }
    const data = {
      text,
      isAnonymous,
      isPrivate,
    };
    onSave(data);
  };

  const handleClose = () => {
    setText('');
    setIsAnonymous(false);
    setIsPrivate(false);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="testimonial-modal-title"
    >
      <Box sx={style}>
        <Typography id="testimonial-modal-title" variant="h6" component="h2">
          Share a Testimony
        </Typography>
        <TextField
          margin="normal" fullWidth label="Your Testimony" multiline rows={6}
          value={text} onChange={(e) => setText(e.target.value)}
        />
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={isAnonymous} onChange={(e) => setIsAnonymous(e.target.checked)} />}
            label="Submit Anonymously"
          />
          <FormControlLabel
            control={<Checkbox checked={isPrivate} onChange={(e) => setIsPrivate(e.target.checked)} />}
            label="Make this private (visible to leadership only)"
          />
        </FormGroup>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleClose} sx={{ mr: 1 }}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Share'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default TestimonialModal;